import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import GameComponent from "game/app/components/game/game-component";
import {Link, NavLink, withRouter} from "react-router-dom";
import {Collapse, Nav, NavItem} from "reactstrap";
import VideoBtn from "game/app/components/video-btn";

class NavbarGameDefault extends GameComponent {
    render() {
        if (!this.props.gameInstance.instance) return ('');

        let endTimestamp = this.props.gameInstance.instance.data.game_definition.properties.timestamp_end;
        let endDate = new Date(endTimestamp);

        return (
            <div className='bottom-menu'>
                <div className='info'>
                    Není ti jasné, jak hra probíhá? <Link to={{ pathname: `/pravidla`, state: { rules: 'secondary' }}}>Přečti si pravidla</Link>, nebo si <VideoBtn videoId='_l_4RgfShzs' btnClassName='video-link'>pusť video</VideoBtn>.
                    <div className='ending'>{ endDate > Date.now() ? "Hra končí" : "Hra byla ukončena " } { this.formatTime(endTimestamp) }</div>
                </div>
                <Collapse isOpen={this.props.toggle} navbar>
                    <ul className='navbar-nav'>
                        <li className='nav-item'><NavLink exact className='nav-link' to={`/game/${this.getInstanceId()}/`}>Přehled</NavLink></li>
                        <li className='nav-item'><NavLink className='nav-link' to={`/game/${this.getInstanceId()}/bonus-tasks`}>Bonusové úkoly</NavLink></li>
                    </ul>
                </Collapse>
            </div>
        )
    }
}


function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth,
        gameInstance: state.gameInstance
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(NavbarGameDefault));
